import { OAuthApplication, OAuthConfig } from '@betha-plataforma/oauth';

import { environment } from '../../environments/environment';

type SuiteServiceKey = 'oauth' | 'service-login' | 'usuarios';

declare global {
  interface Window {
    ___bth?: {
      envs?: {
        suite?: Partial<Record<SuiteServiceKey, { v1?: { host?: string } }>>;
      };
    };
  }
}

function resolveSuiteUrl(service: SuiteServiceKey): string {
  return window.___bth?.envs?.suite?.[service]?.v1?.host ?? environment.oauth.url;
}

function buildOAuthConfig(): OAuthConfig {
  const oauthUrl = resolveSuiteUrl('oauth');
  const serviceLoginUrl = resolveSuiteUrl('service-login');
  const usuariosUrl = resolveSuiteUrl('usuarios');

  return {
    scope: environment.authentication.scope,
    clientId: environment.authentication.clientId,
    redirectUri: `${window.location.origin}/`,
    silentRedirectUri: `${window.location.origin}/assets/silent-callback.html`,
    provider: {
      authorization_endpoint: `${oauthUrl}/authorize`,
      check_session_iframe: `${serviceLoginUrl}/openidsso.jsp`,
      end_session_endpoint: `${serviceLoginUrl}/logout`,
      introspect_endpoint: `${oauthUrl}/tokeninfo`,
      token_endpoint: `${oauthUrl}/token`,
      userinfo_endpoint: `${usuariosUrl}/api/usuarios/@me`
    }
  };
}

export const oAuthConfig: OAuthConfig = buildOAuthConfig();
export const oAuthApplication: OAuthApplication = new OAuthApplication(oAuthConfig);
